// products modules
import axios from '@/api/http_client';
import { ZIPCODE_URL, MOBILE_URL, ZIPCODE_URL_NO_LOGIN} from '../../api/url.js';
import Router from '../../router'

// initial state
const state = {
  allGroups: [],
  currentGroup: '',
  search: '',
  device: '',
  homeWithinRadius: null,
  homeRadiusChecked: false,
  checkoutWithinRadius: false,
  checkoutRadiusChecked: false,
  zipcode: '',
  validPurchase: false,
  radiusCheckoutError: '',
  radiusHomeError: '',
  showModal: false,
  mobile: false,
  componentDisplayOnAccount: 'orders',
  windowHeight: null,
  windowWidth: null,
  warehouseLocation: localStorage.getItem('warehouseLocationWeb'),
  userZip: localStorage.getItem('userZipcode'),
  loginModalVisibilityGlobal: false,
  registerModalVisibilityGlobal: false,
  guestCheckoutModalVisiblity: false,
  shippingMethodModalVisibility: false,
  shippingMethodModalVisibility_mobile: false,
  productDetailImg: null,
  productDetailImgVisibility: null,
  warehouseSelectionModalVisibility: false,
  zipcodeModalVisibility: false,
  shippingMethodGlobal: localStorage.getItem('shippingMethodGlobal') ? localStorage.getItem('shippingMethodGlobal') : 'Delivery',
  currentLang: localStorage.Lang,
  wxModalVisible: false,
  deliveryCodelists:[],
  mobileProductDetailsModalVisible: false
}

// actions
const actions = {
  fetchGroups: ({ commit }, data) => {
    axios({ url: `${MOBILE_URL}/group/`, method: 'GET', headers: {Location: localStorage.getItem('warehouseLocationWeb')} })
    .then( res => {
      commit('updateGroups', res.data)
    })
    .catch(err => {

    })
  },
  validateDeliveryRadius(context, address) {
      const config = {
        method: 'get',
        url: ZIPCODE_URL_NO_LOGIN,
      };
      axios(config)
      .then(response => {
        let found = false;
        let location = '';
        let localZip = '';
        response.data.map(code => {
          if (address === code.zipcode) {
            found = true;
            location = code.State;
            localZip = code.Zipcode;
            if (Router.history.current.name !== 'purchase') {
            setTimeout(() => {
                Router.go();
              }, 500);
            }
          }
        });
        if (Router.history.current.name === 'purchase') {
          context.commit('validateRadiusPurchase', found);
          context.commit('updateWarehouseLocation', location);
          localStorage.setItem('warehouseLocationWeb', location);
        } else {
          context.commit('validateRadiusHome', found);
          localStorage.setItem('warehouseLocationWeb', location);
          localStorage.setItem('userZipcode', localZip);
          context.commit('updateWarehouseLocation', location);
          context.commit('updateUserZipcode', localZip);
        }
      }, (err) => {
        if (Router.history.name === 'home') {
          context.commit('homeRadiusError', err);
        } else if (Router.history.name === 'checkout') {
          context.commit('purchaseRadioError', err);
        }
      });
    },

    getDeliveryCodeList(context) {
      const config = {
        method: 'get',
        url: ZIPCODE_URL_NO_LOGIN,
        headers: {Location: localStorage.getItem('warehouseLocationWeb')},
      };
      axios(config)
      .then((response) => {
        context.commit('getDeliveryCodeList', response.data);
      }, (err) => {
        console.log("getDeliveryCodeList error:", err);
      })
    },

  };

// mutations
const mutations = {
  updateGroups(state, data) {
    state.allGroups = data
  },
  updateCurrentGroup(state, data) {
   state.currentGroup = data
  },
  homeRadiusError(state, payload) {
    state.radiusHomeError = payload;
  },
  radiusCheckoutError(state, payload) {
    state.radiusCheckoutError = payload;
  },
  updateSearchTerm(state, data) {
    state.search = data
  },
  updateDevice(state, payload) {
    state.device = payload;
  },
  validateRadiusHome(state, payload) {
    state.homeWithinRadius = payload;
    state.homeRadiusChecked = true;
  },
  resetHomeRadiusChecked(state, payload) {
    state.homeRadiusChecked = false;
  },
  updateWarehouseLocation(state, payload) {
    state.warehouseLocation = payload;
  },
  validateRadiusPurchase(state, payload) {
    state.checkoutWithinRadius = payload;
    state.checkoutRadiusChecked = true;
  },
  updateZipCode(state, payload) {
    state.zipcode = payload;
  },
  toggleModal(state, payload) {
    state.showModal = payload;
    // state.showModal = false;
  },
  resetHomeWithinRadius(state, payload) {
    state.homeWithinRadius = null;
  },
  handleNavToAccountFromNavbar(state, payload) {
    state.componentDisplayOnAccount = payload;
  },
  mobileDevice(state, payload) {
    state.mobile = payload;
  },
  handleWindowResize(state, payload) {
    state.windowHeight = payload.windowHeight;
    state.windowWidth = payload.windowWidth;
  },
  toggleLoginModalVisibility(state, payload) {
    state.loginModalVisibilityGlobal = payload;
  },
  toggleRegisterModalVisibility(state, payload) {
    state.registerModalVisibilityGlobal = payload;
  },
  toggleGuestCheckoutVisiblity(state, payload) {
    state.guestCheckoutModalVisiblity = payload;
  },
  toggleShippingMethodModalVisibility(state, payload) {
    state.shippingMethodModalVisibility = payload;
  },
  toggleShippingMethodModalVisibility_mobile(state, payload) {
    state.shippingMethodModalVisibility_mobile = payload;
  },
  toggleProductDetailImgVisibility(state, payload) {
    state.productDetailImg = payload.img;
    state.productDetailImgVisibility = payload.status;
  },
  toggleWarehouseSelectionModalVisibility(state, payload) {
    state.warehouseSelectionModalVisibility = payload;
  },
  toggleZipcodeModalVisibility(state, payload) {
    state.zipcodeModalVisibility = payload;
  },
  updateShippingMethodGlobal(state, payload) {
    localStorage.setItem('shippingMethodGlobal', payload);
    state.shippingMethodGlobal = payload;
  },
  updateUserZipcode(state, payload) {
    state.userZip = payload;
  },
  changeLang(state,payload) {
    state.currentLang = payload;
  },
  showWxModal(state) {
    state.wxModalVisible = true;
  },
  hideWxModal(state) {
    state.wxModalVisible = false;
  },
  getDeliveryCodeList(state, payload) {
    state.deliverylist = payload
  },
  showMobileProductDetailsModal(state) {
    state.mobileProductDetailsModalVisible = true;
  },
  hideMobileProductDetailsModal(state) {
    state.mobileProductDetailsModalVisible = false;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/navbar.js